module.exports = __webpack_public_path__ + "static/media/board-approved-logo@2x.1a48b870.png";